import { Box, Divider, ListItem, ListItemText, Stack } from "@mui/material";
import React from "react";

import { useUserProfile } from "api/services/useUserProfile";
import { NumberedList } from "components/common/NumberedList/NumberedList";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useIsUserSciduck } from "hooks/useIsUserSciduck/useIsUserSciduck";
import { useUser } from "hooks/user/useUser";
import { GroundlightButton } from "new-components/buttons/GroundlightButton";
import { Typography } from "new-components/typography/Typography";
import { selectDismissedOnboardings, setDismissedOnboardings } from "store/slices/Onboardings/onboardingsSlice";

import queryDetailsUsageExampleSrc from "../assets/query-details-usage-example.png";
import { ModalStep } from "../types";


export function useInitialStep(): ModalStep | null {
  const user = useUser();
  const isUserSciDuck = useIsUserSciduck();
  const { updateUserProfile } = useUserProfile();

  const dismissedOnboardings = useAppSelector(selectDismissedOnboardings);
  const dispatch = useAppDispatch();
  const shouldSeeFirstUseOfQueryDetailsModal =
    !isUserSciDuck &&
    !user.userprofile.query_detail_onboarded &&
    !dismissedOnboardings.queryDetail;

  const handleConfirmation = () => {
    updateUserProfile({
      query_detail_onboarded: true,
    });
    dispatch(
      setDismissedOnboardings({
        queryDetail: true,
      })
    );
  };

  if (shouldSeeFirstUseOfQueryDetailsModal) {
    return {
      onCLose: handleConfirmation,
      title: "Query Details",
      size: "medium",
      body: (
        <Stack
          direction="column"
          divider={<Divider className="border-neutral-light" orientation="horizontal" flexItem variant="middle" />}
          spacing="25px"
          alignItems="center"
        >
          <Typography
            variant="subtitle"
            fontWeight="semibold"
            align="center"
            className="text-neutral-darkest"
          >
            The query details view allows you to focus on individual image queries.
          </Typography>

          <Stack direction="row" alignItems="center">
            <NumberedList>
              <ListItem>
                <ListItemText primary="Select query to focus on." />
              </ListItem>

              <ListItem>
                <ListItemText primary="Current answer for selected image query. Click here to add/edit answer." />
              </ListItem>
            </NumberedList>

            <Box component="img" src={queryDetailsUsageExampleSrc} className="w-[516px]" />
          </Stack>

          <GroundlightButton className="w-[200px]" onClick={handleConfirmation} variant="filled">
            <Typography variant="subtitle" fontWeight="semibold" textTransform="uppercase">ok</Typography>
          </GroundlightButton>
        </Stack>
      ),
    };
  }

  return null;
}
